var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "image-picker" },
    [
      _c(
        "div",
        { staticClass: "image-list" },
        [
          _vm._l(_vm.images, function (item, index) {
            return _c(
              "div",
              {
                key: item.id,
                staticClass: "image-item",
                on: {
                  click: function ($event) {
                    return _vm.previewImage(index)
                  },
                },
              },
              [
                _c("img", {
                  staticClass: "image",
                  attrs: { src: item.url, alt: "" },
                }),
                _c(
                  "div",
                  {
                    staticClass: "delete-button",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.removeImage(index)
                      },
                    },
                  },
                  [_vm._v(" × ")]
                ),
              ]
            )
          }),
          _vm.images.length < _vm.maxCount
            ? _c(
                "div",
                {
                  staticClass: "image-add",
                  on: { click: _vm.openImageAction },
                },
                [
                  _c("i", { staticClass: "el-icon-plus" }),
                  _c("span", [_vm._v(" 添加图片 ")]),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
      _c("div", { staticClass: "image-tip" }, [
        _vm._v(" " + _vm._s(_vm.tip) + " "),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加图片",
            visible: _vm.actionVisible,
            width: "320px",
            "append-to-body": "",
            "close-on-click-modal": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.actionVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "action-list" }, [
            _c(
              "div",
              { staticClass: "action-option" },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      size: "medium",
                      plain: "",
                      icon: "el-icon-camera",
                    },
                    on: { click: _vm.takePhoto },
                  },
                  [_vm._v(" 拍照 ")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "action-option" },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      size: "medium",
                      plain: "",
                      icon: "el-icon-picture",
                    },
                    on: { click: _vm.chooseAlbum },
                  },
                  [_vm._v(" 从相册选择 ")]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _c("input", {
        ref: "cameraInput",
        staticClass: "hidden-input",
        attrs: { type: "file", accept: "image/*", capture: "environment" },
        on: { change: _vm.handleFileChange },
      }),
      _c("input", {
        ref: "albumInput",
        staticClass: "hidden-input",
        attrs: { type: "file", accept: "image/*", multiple: "" },
        on: { change: _vm.handleFileChange },
      }),
      _vm.previewVisible
        ? _c(
            "div",
            {
              staticClass: "preview-mask",
              on: {
                click: _vm.closePreview,
                touchstart: _vm.handleTouchStart,
                touchend: _vm.handleTouchEnd,
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "preview-close",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.closePreview($event)
                    },
                  },
                },
                [_vm._v(" × ")]
              ),
              _vm.images.length > 1
                ? _c(
                    "div",
                    {
                      staticClass: "preview-prev",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.previewPrev($event)
                        },
                      },
                    },
                    [_vm._v(" ‹ ")]
                  )
                : _vm._e(),
              _vm.currentPreview
                ? _c("img", {
                    staticClass: "preview-image",
                    attrs: { src: _vm.currentPreview.url, alt: "" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  })
                : _vm._e(),
              _vm.images.length > 1
                ? _c(
                    "div",
                    {
                      staticClass: "preview-next",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.previewNext($event)
                        },
                      },
                    },
                    [_vm._v(" › ")]
                  )
                : _vm._e(),
              _c("div", { staticClass: "preview-index" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.previewIndex + 1) +
                    " / " +
                    _vm._s(_vm.images.length) +
                    " "
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }